/** Applies to FLAI explanation and workflow requests, charged once per request.
 * Change this application setting and redeploy to enable or disable account credits.
 * AI provider usage is independent of account credit deduction.
 */
export const FLAI_REQUEST_CONFIG = {
	deductCredits: false,
	/** Requests per authenticated user per UTC calendar day.
	 * A workflow counts once, not once per tool step. Valid attempts count even if they fail later.
	 * 0 disables requests for that tier; null means unlimited. Paid means an active paid module.
	 */
	dailyRequestLimit: {
		free: 5 as number | null,
		paid: 100 as number | null
	}
};


export const FLAI_DAILY_LIMIT_MESSAGE = 'You have reached your daily FLAI request limit. Try again after 00:00 UTC.';
